import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { FiPlus, FiLoader } from 'react-icons/fi';
import { urlService } from '../services/urlService';

const UrlForm = ({ onUrlCreated }) => {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);

  const isValidUrl = (string) => {
    try {
      const urlObj = new URL(string);
      return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
    } catch (_) {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!url.trim()) {
      toast.error('Please enter a URL');
      return;
    }

    if (!isValidUrl(url.trim())) {
      toast.error('Please enter a valid URL (including http:// or https://)');
      return;
    }

    try {
      setLoading(true);
      const newUrl = await urlService.createUrl(url.trim());
      onUrlCreated(newUrl);
      setUrl('');
      toast.success('Short URL created successfully!');
    } catch (error) {
      toast.error(error.message || 'Failed to create short URL');
    } finally {
      setLoading(false);
    }
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      if (text) {
        setUrl(text);
      }
    } catch (error) {
      toast.error('Failed to paste from clipboard');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1 relative">
          <input
            type="text"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="Enter your long URL here (e.g., https://example.com/very-long-url)"
            className="w-full px-4 py-3 pr-20 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            disabled={loading}
          />
          <button
            type="button"
            onClick={handlePaste}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 px-3 py-1 text-xs text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded"
          >
            Paste
          </button>
        </div>
        
        <button
          type="submit"
          disabled={loading || !url.trim()}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2 min-w-[120px]"
        >
          {loading ? (
            <>
              <FiLoader className="h-4 w-4 animate-spin" />
              <span>Creating...</span>
            </>
          ) : (
            <>
              <FiPlus className="h-4 w-4" />
              <span>Shorten</span>
            </>
          )}
        </button>
      </div>
      
      <p className="text-xs text-gray-500">
        Enter a valid URL starting with http:// or https://
      </p>
    </form>
  );
};

export default UrlForm; 